export default {
    id: 386799403187,
    name: 'United States',
    provinces: [
        {
            id: 3988820590771,
            name: 'Alabama',
        },
        {
            id: 3988820623539,
            name: 'Alaska',
        },
        {
            id: 3988820656307,
            name: 'American Samoa',
        },
        {
            id: 3988820689075,
            name: 'Arizona',
        },
        {
            id: 3988820721843,
            name: 'Arkansas',
        },
        {
            id: 3988822524083,
            name: 'Armed Forces Americas',
        },
        {
            id: 3988822556851,
            name: 'Armed Forces Europe',
        },
        {
            id: 3988822589619,
            name: 'Armed Forces Pacific',
        },
        {
            id: 3988820754611,
            name: 'California',
        },
        {
            id: 3988820787379,
            name: 'Colorado',
        },
        {
            id: 3988820820147,
            name: 'Connecticut',
        },
        {
            id: 3988820852915,
            name: 'Delaware',
        },
        {
            id: 3988820885683,
            name: 'District of Columbia',
        },
        {
            id: 3988820918451,
            name: 'Federated States of Micronesia',
        },
        {
            id: 3988820951219,
            name: 'Florida',
        },
        {
            id: 3988820983987,
            name: 'Georgia',
        },
        {
            id: 3988821016755,
            name: 'Guam',
        },
        {
            id: 3988821049523,
            name: 'Hawaii',
        },
        {
            id: 3988821082291,
            name: 'Idaho',
        },
        {
            id: 3988821115059,
            name: 'Illinois',
        },
        {
            id: 3988821147827,
            name: 'Indiana',
        },
        {
            id: 3988821180595,
            name: 'Iowa',
        },
        {
            id: 3988821213363,
            name: 'Kansas',
        },
        {
            id: 3988821246131,
            name: 'Kentucky',
        },
        {
            id: 3988821278899,
            name: 'Louisiana',
        },
        {
            id: 3988821311667,
            name: 'Maine',
        },
        {
            id: 3988821344435,
            name: 'Marshall Islands',
        },
        {
            id: 3988821377203,
            name: 'Maryland',
        },
        {
            id: 3988821409971,
            name: 'Massachusetts',
        },
        {
            id: 3988821442739,
            name: 'Michigan',
        },
        {
            id: 3988821475507,
            name: 'Minnesota',
        },
        {
            id: 3988821508275,
            name: 'Mississippi',
        },
        {
            id: 3988821541043,
            name: 'Missouri',
        },
        {
            id: 3988821573811,
            name: 'Montana',
        },
        {
            id: 3988821606579,
            name: 'Nebraska',
        },
        {
            id: 3988821639347,
            name: 'Nevada',
        },
        {
            id: 3988821672115,
            name: 'New Hampshire',
        },
        {
            id: 3988821704883,
            name: 'New Jersey',
        },
        {
            id: 3988821737651,
            name: 'New Mexico',
        },
        {
            id: 3988821770419,
            name: 'New York',
        },
        {
            id: 3988821803187,
            name: 'North Carolina',
        },
        {
            id: 3988821835955,
            name: 'North Dakota',
        },
        {
            id: 3988821868723,
            name: 'Northern Mariana Islands',
        },
        {
            id: 3988821901491,
            name: 'Ohio',
        },
        {
            id: 3988821934259,
            name: 'Oklahoma',
        },
        {
            id: 3988821967027,
            name: 'Oregon',
        },
        {
            id: 3988821999795,
            name: 'Palau',
        },
        {
            id: 3988822032563,
            name: 'Pennsylvania',
        },
        {
            id: 3988822065331,
            name: 'Puerto Rico',
        },
        {
            id: 3988822098099,
            name: 'Rhode Island',
        },
        {
            id: 3988822130867,
            name: 'South Carolina',
        },
        {
            id: 3988822163635,
            name: 'South Dakota',
        },
        {
            id: 3988822196403,
            name: 'Tennessee',
        },
        {
            id: 3988822229171,
            name: 'Texas',
        },
        {
            id: 3988822261939,
            name: 'Utah',
        },
        {
            id: 3988822294707,
            name: 'Vermont',
        },
        {
            id: 3988822491315,
            name: 'Virgin Islands',
        },
        {
            id: 3988822327475,
            name: 'Virginia',
        },
        {
            id: 3988822360243,
            name: 'Washington',
        },
        {
            id: 3988822393011,
            name: 'West Virginia',
        },
        {
            id: 3988822425779,
            name: 'Wisconsin',
        },
        {
            id: 3988822458547,
            name: 'Wyoming',
        },
    ],
}
